import { HTTPServerError } from '../errorHandlers/errorClass.js';

export async function get({ url }) {
  const response = await fetch(url);

  if (!response.ok) {
    throw new HTTPServerError(response.statusText, { status: response.status });
  }

  const result = response.json && response.status !== 204 ? await response.json() : null;

  return { response, result };
}
